import React, { useState, useEffect } from 'react';
import { createUseStyles } from 'react-jss';
import io from 'socket.io-client';
import { getAppURL } from 'shared/lib/clientSettings';
import ProgressBar from '~/components/ProgressBar';
import LoadingOverlay from './LoadingOverlay';
import { WEBSOCKET_MSG_ID } from 'shared/constants';

type Props = {
  isUploading: boolean
}

const progressBarStyle = {
  width: '100%',
  height: '10px',
  margin: 'auto'
};

// Read upload progress from server and display progress status
export default function UploadProgressBar(props: Props) {
  const { isUploading } = props;

  const [uploadProgress, setUploadProgress] = useState(0);
  const c = useStyles();

  useEffect(() => {
    const socket = io(getAppURL());

    socket.on(WEBSOCKET_MSG_ID.ASSET_UPLOAD_PROGRESS, ({ progress }) => {
      setUploadProgress(progress);
      if (Math.round(progress * 100) === 100) {
        // Hide the progress bar after a delay
        setTimeout(() => {
          setUploadProgress(0);
        }, 2000);
      }
    });

    socket.on(WEBSOCKET_MSG_ID.ASSET_UPLOAD_ERROR, (err) => {
      console.error(err);
      setUploadProgress(0);
    });

    return () => {
      socket.close();
    };
  }, []);

  return (
    <div className={c.progressBar}>
      {
        isUploading && uploadProgress === 0 ?
          <LoadingOverlay /> :
          <ProgressBar progress={uploadProgress} containerStyle={progressBarStyle} />
      }
    </div>
  );
}

const styles = {
  progressBar: {
    '& path': {
      stroke: 'green'
    }
  }
};
const useStyles = createUseStyles(styles);
